import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import api from "../../api";

// Reuse CallLogRow and ConversationHistory from AdminProperties.js
// (Copy their code here for now, or refactor later)

function formatDateTime(dt) {
  return new Date(dt).toLocaleString();
}
const statusColors = {
  completed: "bg-green-100 text-green-700",
  failed: "bg-red-100 text-red-700",
  "in progress": "bg-blue-100 text-blue-700",
  pending: "bg-gray-200 text-gray-700",
};
function capitalizeEachWord(str) {
  return str?.replace(/\b\w/g, (c) => c.toUpperCase()) || "";
}
const ConversationHistory = ({ history }) => (
  <div className="space-y-4">
    {history.map((msg, idx) => (
      <div
        key={idx}
        className={`flex  ${
          msg.role === "ai" ? "justify-start" : "justify-end"
        }`}
      >
        <div className="relative">
          {/* Bubble */}
          <div
            className={`px-5 py-3 rounded-2xl shadow-md text-base leading-relaxed break-words whitespace-pre-line min-w-[120px] max-w-xl"
              ${
                msg.role === "ai"
                  ? "bg-blue-100 text-blue-900 rounded-bl-none"
                  : "bg-green-100 text-green-900 rounded-br-none"
              }
              ${idx === history?.length - 1 && "mb-5"}
            `}
            style={{
              borderBottomLeftRadius: msg.role === "ai" ? "0.5rem" : "1rem",
              borderBottomRightRadius: msg.role === "ai" ? "1rem" : "0.5rem",
              wordBreak: "break-word",
              whiteSpace: "pre-line",
            }}
          >
            <span className="block text-xs font-bold mb-1 opacity-80">
              {msg.role === "ai" ? "AI" : "User"}
            </span>
            <span className="block">{msg.content}</span>
          </div>
          {/* Bubble tail */}
          <div
            className={`absolute bottom-0 ${
              msg.role === "ai" ? "-left-2" : "-right-2"
            } w-0 h-0 border-t-8 border-t-blue-100 border-x-8 border-x-transparent`}
            style={{
              borderTopColor: msg.role === "ai" ? "#DBEAFE" : "transparent",
              left: msg.role === "ai" ? "-8px" : "auto",
              right: msg.role === "ai" ? "auto" : "-8px",
            }}
          />
        </div>
      </div>
    ))}
  </div>
);

const statusBorderColors = {
  completed: "border-l-4 border-green-400",
  failed: "border-l-4 border-red-400",
  "in progress": "border-l-4 border-blue-400",
  pending: "border-l-4 border-gray-300",
};
const statusChipColors = {
  completed: "bg-green-100 text-green-700 border-green-200",
  failed: "bg-red-100 text-red-700 border-red-200",
  "in progress": "bg-blue-100 text-blue-700 border-blue-200",
  pending: "bg-gray-100 text-gray-700 border-gray-200",
};
const intentChipColors = {
  hot: "bg-orange-100 text-orange-700 border-orange-200",
  warm: "bg-yellow-100 text-yellow-700 border-yellow-200",
  cold: "bg-blue-100 text-blue-700 border-blue-200",
};

const CallLogsForQueue = () => {
  const { queueId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const propertyTitle = location.state?.propertyTitle;
  const agentName = location.state?.agentName;
  const [callLogs, setCallLogs] = useState([]);
  const [logsLoading, setLogsLoading] = useState(false);

  useEffect(() => {
    const fetchLogs = async () => {
      setLogsLoading(true);
      try {
        const res = await api.get("ai-voice-caller/agent-calls/");
        setCallLogs(res.data || []);
      } catch (err) {
        setCallLogs([]);
      } finally {
        setLogsLoading(false);
      }
    };
    fetchLogs();
  }, [queueId]);

  const filteredLogs = callLogs.filter(
    (log) => String(log.property_lead_queue) === String(queueId)
  );
  // console.log(filteredLogs);
  return (
    <div className="p-4">
      <button
        className="mb-4 px-4 py-2 rounded bg-gray-200 hover:bg-gray-300 text-gray-700"
        onClick={() =>
          navigate("/admin-properties", { state: { activeTab: "queue" } })
        }
      >
        &larr; Back to Admin Properties
      </button>
      <h2 className="text-2xl font-bold mb-2 text-[#55C5D0]">
        Call Logs for Property: {propertyTitle || queueId}
      </h2>
      {/* <div className="mb-6 text-base text-gray-700">
        <span className="font-semibold">Agent:</span> {agentName || "-"}
      </div> */}
      {logsLoading ? (
        <div className="text-gray-400">Loading call logs...</div>
      ) : filteredLogs.length === 0 ? (
        <div className="text-gray-400">No call logs for this queue.</div>
      ) : (
        <div className="flex flex-col gap-8">
          {filteredLogs.map((log) => (
            <div
              key={log.id}
              className={`w-full relative bg-gradient-to-br from-white to-gray-50 ${
                statusBorderColors[log.status?.toLowerCase()] ||
                "border-l-4 border-gray-200"
              } rounded-2xl shadow-lg p-6 flex flex-col gap-3 w-[90%]  transition-all duration-200 group`}
            >
              {/* Status chip */}
              <div className="absolute top-4 right-4 flex gap-2 items-center">
                <span className="text-xs font-semibold text-gray-500 mr-1">
                  Status:
                </span>
                <span
                  className={`px-3 py-1 rounded-full text-xs font-semibold border ${
                    statusChipColors[log.status?.toLowerCase()] ||
                    "bg-gray-100 text-gray-700 border-gray-200"
                  }`}
                >
                  {capitalizeEachWord(log.status)}
                </span>
              </div>
              {/* Property Title */}
              {/* <div className="flex items-center gap-2 mb-1">
                <span className="text-base font-bold text-[#55C5D0] truncate">
                  {log.property_title || "No Property Title"}
                </span>
              </div> */}
              {/* Phone number */}
              <div
                className="flex items-center gap-2 text-lg font-bold text-gray-800 truncate"
                title={log.phone_number}
              >
                {/* <svg
                  className="w-5 h-5 text-[#55C5D0]"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  viewBox="0 0 24 24"
                >
                  <path d="M22 16.92V19a2 2 0 0 1-2 2A19.72 19.72 0 0 1 3 5a2 2 0 0 1 2-2h2.09a1 1 0 0 1 1 .75l1.13 4.52a1 1 0 0 1-.29.95l-1.27 1.27a16 16 0 0 0 6.29 6.29l1.27-1.27a1 1 0 0 1 .95-.29l4.52 1.13a1 1 0 0 1 .75 1z" />
                </svg> */}
                <span className="truncate">{agentName || ""}</span>
              </div>
              {/* Chips row */}
              <div className="flex flex-wrap gap-2 mb-1">
                <span
                  className={`px-2 py-0.5 rounded-full text-xs font-medium border ${
                    intentChipColors[log.intent?.toLowerCase()] ||
                    "bg-gray-100 text-gray-700 border-gray-200"
                  }`}
                >
                  {capitalizeEachWord(log.intent)}
                </span>
                <span
                  className={`px-2 py-0.5 rounded-full text-xs font-medium border ${
                    log.is_interested
                      ? "bg-green-50 text-green-700 border-green-200"
                      : "bg-gray-50 text-gray-500 border-gray-200"
                  }`}
                >
                  {log.is_interested ? "Interested" : "Not Interested"}
                </span>
                <span className="px-2 py-0.5 rounded-full text-xs font-medium border bg-gray-50 text-gray-500 border-gray-200">
                  {capitalizeEachWord(log.timeline)}
                </span>
              </div>
              {/* AI Summary */}
              <div className="bg-blue-50 border border-blue-100 rounded-lg p-3 text-sm text-blue-900 italic shadow-sm">
                <strong>AI Summary:</strong> {log.ai_summry}
              </div>
              {/* Created at */}
              <div className="flex items-center gap-2 text-xs text-gray-400 mt-1">
                <svg
                  className="w-4 h-4"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  viewBox="0 0 24 24"
                >
                  <circle cx="12" cy="12" r="10" />
                  <path d="M12 6v6l4 2" />
                </svg>
                <span>{formatDateTime(log.created_at)}</span>
              </div>
              {/* Conversation History always visible */}
              <div className="mt-4">
                <h4 className="text-sm font-semibold text-[#55C5D0] mb-2">
                  Conversation History
                </h4>
                <div className="max-h-[400px] overflow-y-auto bg-gray-50 rounded-lg p-3 border border-gray-100">
                  <ConversationHistory history={log.conversation_history} />
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default CallLogsForQueue;
